<template>
  <aside id="mainSidebar" data-ts="SideBar">
    <div data-ts="Panel" style="background: #222">
      <div class="sidebar-header">
        <a href="/support/search">
          <img
            class="logo"
            src="/images/ts_logo_white.svg"
            alt="Tradeshift Logo"
          />
          <h3>Juvo</h3>
        </a>
      </div>
      <div class="sidebar-content">
        <ul class="sidebar-outer-ul list-unstyled">
          <li
            class="sidebar-outer-li"
            v-for="(item, index) in orderedMenu"
            :key="index"
          >
            <a
              :class="{ activeMenuItem: currentLocation === item.href }"
              v-if="!item.sub_menu"
              :href="item.href"
            >
              {{ item.label }}
            </a>
            <a v-if="item.sub_menu" style="cursor: default" href="#">
              {{ item.label }}
            </a>
            <ul class="sidebar-inner-ul">
              <li
                class="sidebar-inner-li"
                v-for="subItem in item.sub_menu"
                :key="subItem.label"
              >
                <a
                  :class="{ activeMenuItem: currentLocation === subItem.href }"
                  :href="subItem.href"
                >
                  {{ subItem.label }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="sidebar-version">
        Juvo-{{ $runtime.TS_ENV }}-{{ $runtime.GIT_HASH.substring(0, 7) }}
      </div>
      <div class="sidebar-footer">
        <div class="user-details">
          <strong>{{ menuItems.user.Username }}</strong>
          <br />
          <span v-if="$runtime.permissions.can_view_search === false">
            <small>{{ menuItems.user.CompanyName }}</small>
          </span>
          <a
            v-if="$runtime.permissions.can_view_search === true"
            :href="`/support/tenant/${menuItems.user.CompanyAccountId}`"
          >
            <small>{{ menuItems.user.CompanyName }}</small>
          </a>
        </div>
        <div class="logout-button">
          <a href="/logout">
            <i class="ts-icon-logout"></i>
          </a>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  inject: {
    $runtime: {
      default: {
        permissions: {},
      },
    },
  },
  props: {
    menuItems: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentLocation: location.pathname,
    };
  },
  computed: {
    orderedMenu() {
      const items = [...this.menuItems.items];
      return items.sort((a, b) => a.order - b.order);
    },
  },
};
</script>

<style scoped>
a {
  color: white;
}

.sidebar-header a {
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-header h3 {
  margin: 0;
  color: white;
  font-weight: 100;
  font-size: 1.5rem;
}

.sidebar-header .logo {
  height: 50px;
}

.user-details {
  flex: 1 0 220px;
  overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.logout-button {
  flex: 0 0 76px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
